module.exports = __webpack_public_path__ + "static/media/job.dd726a11.png";